import { icons } from 'assets';
import { RouteAwareCrumbs } from 'Components/shared/breadcrumbs';
import { Tab, TabPanel, Tabs } from 'Components/shared/tab';
import TableDisplay from 'Components/shared/table';
import Text from 'Components/shared/text';
import { EmptyComponent, Status, TransactionType } from 'Components/shared/transactions';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUsersTransactions } from 'services/transactionService';
import { currencyMap, currencyNameMap } from 'utils/constants/maps';
import { capitalize, convertDate } from 'utils/stringServices';
import styles from './history.module.css';


const format = Intl.NumberFormat("en-US");
const dateFormat = Intl.DateTimeFormat("en-GB");
const tableStructure = {
    0: {
      field: "transactionType",
      renderItem: (rowData) => <TransactionType type={rowData.type == "deposit" ? "credit" : "debit"} />,
      cellStyle: {
          cursor: "pointer",
      },
    },
    1: {
      renderItem: (rowData) => (
        <Text style={{ fontWeight: "300" }} >
          {capitalize(rowData.type)}: <br /> {rowData.details}
        </Text>
      ),
      cellStyle: {
        minWidth: "220px",
        cursor: "pointer",
      },
    },
    2: {
      renderItem: (rowData) => (
        <Text style={{ fontWeight: "300" }} >
          Date:
          <br /> {convertDate(rowData.timestamp)}
        </Text>
      ),
      cellStyle: {
        minWidth: "110px",
        cursor: "pointer",
      },
    },
    3:{
      renderItem: (rowData) => (
        <Text style={{ fontWeight: "300" }} >
          Currency:
          <br /> { currencyNameMap[rowData.currency]}
        </Text>
      ),
      cellStyle: {
        minWidth: "110px",
        cursor: "pointer",
      },
    },
    4: {
      renderItem: (rowData) => (
        <Text
          style={{
            display: "flex",
            alignItems: "center",
            justifySelf: "flex-end",
            
          }}
          
        >
          {`${currencyMap[rowData.currency] || "₦"}${format.format(rowData.amount)}`}
        </Text>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        justifySelf: "flex-end",
        minWidth: "120px",
        flexGrow: 2,
        paddingRight: "24px",
        cursor: "pointer",
      },
    },
  };



const TransferTransactions = () => {
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState(0);
    const [confirmModal, setConfirmModal] = useState(false);
  
    const {data: transferTransactions} = useGetUsersTransactions("transfer");
    
    const NameMap = {
        "/transaction-history/transfer-transactions":"Transfer Transactions",
        "/transaction-history": "Transaction History"
    }
    return (
        <div className={styles.root}>
            <Text variant="lg" tag="h1" style={{fontWeight:"700"}}>Transfer Transactions</Text>
            <RouteAwareCrumbs nameMap={NameMap} />
            
            <div className={styles.contentContainer}>
                <Text variant="md2" tag="h2" style={{ fontWeight:"700",marginBottom:"24px"}}>Transactions</Text>
                <TableDisplay
            data={transferTransactions}
            column={tableStructure}
            emptyComponent={
              <div className={styles.emptyContainer}>
                <EmptyComponent
                  graphics={
                    <img
                      src={icons.empty_transaction}
                      alt="empty transactions"
                    />
                  }
                  title="Opps! You do not have any transaction history"
                  description="Looks like you do not have any transaction history. Send money to your wallet today to see your transaction history"
                  action={{
                    label: "Go to wallet",
                    onClick: (e) => {},
                    fullWidth: true,
                  }}
                />
              </div>
            }
          />
            </div>
        </div>
    )
}

export default TransferTransactions;